<template>
  <main class="dashboard">
    <div class="d-flex pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">{{ current_page.name }}</h1>
    </div>
    <div class="text" v-html="current_page.description"></div>


      <template v-if="response">
        <div class="card">
        <div
            class="card-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <div>
            <h3><a :href="response.link">{{ response.link }}</a></h3>
            <div class="d-flex flex-column">
                    <span class="text-secondary" v-if="response.best_place">
                      Лучшая позиция в поиске:
                      <b class="text-dark">{{ response.best_place }}</b>
                    </span>
              <span class="text-secondary" v-if="response.links_in_top20">Количество ссылок в поиске: <b
                  class="text-dark">{{ response.links_in_top20 }}</b></span>
              <span class="text-secondary">Дата: <b
                  class="text-dark">{{ response.date }}</b></span>
            </div>
          </div>

          <button class="btn" @click="clearResponse"><b class="h3"><i class="bi bi-x-lg"></i></b>
          </button>
        </div>
        <div class="card-body">
          <div class="btn-group" role="group" aria-label="Basic example">
            <button type="button" :class="`btn ${!is_positive?'btn-danger':'btn-secondary'}`"
                    @click="is_positive=false">Негативные отзывы
            </button>
            <button type="button" :class="`btn ${is_positive?'btn-success':'btn-secondary'}`" @click="is_positive=true">
              Положительные отзывы
            </button>
          </div>
      <template v-for="resp in responses">
          <div class="card w-75 mt-3" v-if="resp.content">
            <div class="card-body">
              <p class="card-text">{{ resp.content }}</p>
            </div>
          </div>
        </template>
          <PagerList class="mt-3" v-bind:pager="response_pager" v-bind:updatePage="updateResponsePage"
                     v-bind:page="response_page"></PagerList>
        </div>
          </div>
      </template>
      <template v-else>
        <div class="table-flex-responsive">
            <div class="row header">
              <div class="col-1"> №</div>
              <div class="col-3"> Ссылка на сайт отзовик</div>
              <div class="col-3"></div>
            </div>
            <template v-for="(object, index) in objects">

              <div class="row line">

                <div class="col-1 number"><div class="sub-head">№</div>{{ (index + 1) + ((page - 1) * size) }}</div>
                <div class="col sub-head">Ссылка на сайт отзовик</div>
                <div class="col-3">
                  <a :href="object.link" target="_blank">{{ object.link }}</a>
                    <div class="d-flex flex-column">
                    <span class="text-secondary" v-if="object.best_place">
                      Лучшая позиция в поиске:
                      <b class="text-dark">{{ object.best_place }}</b>
                    </span>
                      <span class="text-secondary" v-if="object.links_in_top20">Количество ссылок в поиске: <b
                          class="text-dark">{{ object.links_in_top20 }}</b></span>
                      <span class="text-secondary">Дата: <b
                          class="text-dark">{{ object.date }}</b></span>
                      <br>
                      <button class="btn btn-primary btn-sm" style="max-width: 150px;" @click="response=object">
                        Подробнее <i
                          class="bi bi-caret-down"></i></button>
                    </div>
                </div>
                <div class="col sub-head"></div>
                <div class="col">
                   <ResponseChart v-if="object.link_obj_id" v-bind:link_id="object.link_obj_id"></ResponseChart>
                </div>

              </div>
            </template>
            <div v-if="!objects.length" class="row">
              <div  class="col-12 text-center">
                Не добавлено ни одной записи
              </div>
            </div>
            <div v-if="objects.length < max_length">
              <div>
                <button class="btn btn-success" v-on:click="addNote" title="Добавить запись">+</button>
              </div>
            </div>
            </div>


        <PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page"></PagerList>
      </template>





  </main>
</template>

<script>
import dataMixin from './mixins.js';
import {DictionaryApi} from '@/api/dictionary'

export default {
  name: 'ResponsesService',
  mixins: [dataMixin],
  data() {
    return {
      name: 'review_sites',
      responses: [],
      link_obj_id: 285365,
      response: null,
      response_size: 20,
      response_all_count: 0,
      response_page: 1,
      is_positive: false
    }
  },
  computed: {
    response_pager() {
      return this.response_pager = this.$func.getPagerArray(this.response_all_count, this.response_size, this.response_page)
    }
  },
  watch: {
    response() {
      if (this.response) this.getResponse()
    },
    is_positive() {
      if (this.response) this.getResponse()
    },
    response_page() {
      if (this.response) this.getResponse()
    }
  },
  methods: {
    clearResponse() {
      this.response = null;
      this.response_all_count = 0;
      this.response_page = 1;
      this.is_positive = false;
    },
    getResponse() {
      let $this = this;

      DictionaryApi.get_list("reviews",
          this.response_page,
          this.response_size,
          `review_site=${this.response.id}&is_positive=${this.is_positive}`).then((response) => {
        $this.responses = response.results
        $this.response_all_count = response.count;
      })
    },
    updateResponsePage(page) {
      this.response_page = page
    }
  }
}
</script>
<style>
textarea {
  min-width: 250px;
}
</style>


